import React, { useState, FunctionComponent, useEffect, useCallback } from 'react';
import { Presentation } from './presentation';
import { PersonShowModalInterestState } from './types';
import { fetchRecommendInterests } from '../../../services/personProfiles';

type Props = {
  onChangedBody: (name: string, value: any) => void;
  interests: string[];
  target: string;
  onRegisterCommitHandler?: (handler: () => string[]) => void;
};

export const Component: FunctionComponent<Props> = ({
  onChangedBody,
  interests: initialInterests,
  target,
  onRegisterCommitHandler,
}) => {
  const [state, setState] = useState<PersonShowModalInterestState>({
    interests: [],
    targetInterest: '',
    isSearching: true,
    suggestInterests: [],
    recommendInterests: [],
  });

  useEffect(() => {
    setDefaultInterests();
    handleRecommends();
  }, []);

  useEffect(() => {
    setState(prev => ({ ...prev, interests: initialInterests }));
  }, [initialInterests]);

  const setDefaultInterests = () => {
    setState(prev => ({ ...prev, interests: initialInterests }));
  };

  const onChangeBody = (name: string, value: string) => {
    setState(prev => ({ ...prev, [name]: value }));
    if (value === '') {
      setState(prev => ({ ...prev, isSearching: false, suggestInterests: [] }));
    } else {
      setState(prev => ({ ...prev, isSearching: true }));
    }
  };

  const handleClick = (value: string) => {
    if (!state.interests.includes(value)) {
      const newArray = [...state.interests, value];
      setState(prev => ({ ...prev, interests: newArray, suggestInterests: [], isSearching: false, targetInterest: '' }));
      onChangedBody('interests', newArray);
    }
  };

  const handleRecommends = async () => {
    try {
      const response = await fetchRecommendInterests();
      setState(prev => ({ ...prev, recommendInterests: response.recommendInterests, }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = (interest: string) => {
    const updated = state.interests.filter(i => i !== interest);
    setState(prev => ({ ...prev, interests: updated }));
    onChangedBody('interests', updated);
  };

  const handleSend = (value: string) => {
    if (!state.interests.includes(value)) {
      const newArray = [...state.interests, value];
      setState(prev => ({ ...prev, interests: newArray, targetInterest: '', isSearching: false }));
      onChangedBody('interests', newArray);
    }
  };

  const handleClearSuggest = () => {
    setState(prev => ({ ...prev, isSearching: false, suggestInterests: [] }));
  };

  const getInterestsForSave = useCallback((): string[] => {
    const value = state.targetInterest.trim();
    if (value && !state.interests.includes(value)) {
      return [...state.interests, value];
    }
    return state.interests;
  }, [state.targetInterest, state.interests]);

  useEffect(() => {
    onRegisterCommitHandler?.(getInterestsForSave);
  }, [getInterestsForSave, onRegisterCommitHandler]);

  return (
    <Presentation
      state={state}
      onChangeBody={onChangeBody}
      handleClick={handleClick}
      handleDelete={handleDelete}
      handleSend={handleSend}
      handleClearSuggest={handleClearSuggest}
    />
  );
};
